import { createSelector } from '@reduxjs/toolkit';

import type {
  // MenuLayerLevel,
  RootMenuItem,
  // PROMOTION_LEVEL,
  // SportsMenuPromotedMenuItem,
  SportTournamentsMenuLayer,
  // StagesMenuLayer,
  // StagesMenuLayerItem,
} from '../types';
import type { ConstantMenuItem } from 'app/modules/Navigation/types';
import type { ReduxState } from 'app/redux/types';

import { NAMESPACE_LIVE } from 'app/constants/Context';
import {
  createActiveItemDetectionSelector,
  createAllMatchesCountSelector,
  // currentLocation,
} from 'app/modules/Navigation/selectors';
import {
  // composeEntityPath,
  composeSportPath,
  // composeTournamentPath,
  createConstantMenuItem,
  // createMatchMenuItem,
  createSportMenuItem,
  // createStageMenuItem,
  createTournamentMenuItem,
  getPrefixByNamespace,
  parseLocationPath,
} from 'app/modules/Navigation/utils';

import {
  entityLoading,
  entityRequested as requested,
  // matches,
  matchIds,
  // objects,
  sports,
  tournaments,
  // tournamentStages as stages,
  tournamentUnions as unions,
} from '../../Live/selectors/entities';
import {
  createSportTournamentsMenuLayer,
  // createStagesMenuLayer,
} from '../utils';
import {
  applyNavigationState,
  createEntityLayersSelector,
  createEntityMenuItemsSelector,
  // createEntityMenuItemsByPromotionLevelSelector,
  groupBy,
} from './helpers';

import dictionary from './Live.dictionary.json';

const prefix = getPrefixByNamespace(NAMESPACE_LIVE);

export {
  requested,
  entityLoading,
  matchIds,
};

// -- empty menu layers --

const emptySportTournamentsMenuLayers = createEntityLayersSelector(
  sports,
  (sport) => createSportTournamentsMenuLayer({
    sportId: sport.id,
    header: {
      title: sport.name,
      location: composeSportPath({ sportId: sport.id }, prefix),
    },
  }),
);

// const emptyStagesMenuLayers = createEntityLayersSelector(
//   tournaments,
//   (tournament) => createStagesMenuLayer({
//     tournamentId: tournament.id,
//     header: {
//       title: tournament.name,
//       location: composeTournamentPath({
//         sportId: tournament.sportId,
//         tournamentUnionId: tournament.tournamentUnionId,
//         tournamentId: tournament.id,
//       }, prefix),
//     },
//   }),
// );


// -- entity menu items --

const sportMenuItems = createEntityMenuItemsSelector(
  sports,
  (sport) => {
    const dataGaValues = {
      ['data-ga-event']: 'leftmenu-liveCategorySelect',
      ['data-ga-sport-category']: sport.id,
    };

    return createSportMenuItem({ sport, prefix, dataGaValues });
  },
);

const tournamentMenuItems = createEntityMenuItemsSelector(
  unions,
  tournaments,
  (unionsById, tournament) => createTournamentMenuItem({
    tournament,
    caption: unionsById.get(tournament.tournamentUnionId)?.name,
    prefix,
  }),
);

// const stageMenuItems = createEntityMenuItemsSelector(
//   stages,
//   (stage) => createStageMenuItem({ stage, prefix }),
// );

// const matchMenuItems = createEntityMenuItemsSelector(
//   objects,
//   matches,
//   (objects, match) => (
//     createMatchMenuItem({
//       match,
//       objects,
//       prefix,
//     })
//   ),
// );


// -- promoted entity items by promotion level --

// const promotedTournamentMenuItemsByLevel =
//   createEntityMenuItemsByPromotionLevelSelector(
//     unions,
//     tournamentMenuItems,
//     [PROMOTION_LEVEL.SPORT],
//     (unionsById, tournamentMenuItem) => {
//       return unionsById.get(tournamentMenuItem.entity.tournamentUnionId)?.name;
//     },
//   );

// const promotedStageMenuItemsByLevel =
//   createEntityMenuItemsByPromotionLevelSelector(
//     tournaments,
//     stageMenuItems,
//     [PROMOTION_LEVEL.SPORT],
//     (tournamentsById, stageMenuItem) => {
//       return tournamentsById.get(stageMenuItem.entity.tournamentId)?.name;
//     },
//   );


// -- all kind of promoted entity items for concrete level --

// const sportsMenuPromotedMenuItems = createSelector(
//   (state: ReduxState) => (
//     promotedTournamentMenuItemsByLevel(state)?.get(PROMOTION_LEVEL.SPORT) || []
//   ),
//   (state: ReduxState) => (
//     promotedStageMenuItemsByLevel(state)?.get(PROMOTION_LEVEL.SPORT) || []
//   ),
//   (tournamentItems, stageItems) => {
//     return ([] as SportsMenuPromotedMenuItem[])
//       .concat(tournamentItems)
//       .concat(stageItems);
//   },
// );


// -- root menu items --

const CONSTANT_MENU_ITEMS: ConstantMenuItem[] = [
  // createConstantMenuItem({
  //   key: 'live',
  //   label: dictionary.liveLabel,
  //   title: dictionary.liveLabel,
  //   location: '/live',
  //   activeOn: 'exact-match',
  //   dataGaValues: {
  //     ['data-ga-event']: 'leftmenu-live-allEvents',
  //   },
  // }),
  // createConstantMenuItem({
  //   key: 'favorites',
  //   label: dictionary.favoritesLabel,
  //   title: dictionary.favoritesTitle,
  //   location: '/live/favorites',
  //   activeOn: 'prefix-match',
  //   dataGaValues: {
  //     ['data-ga-event']: 'leftmenu-live-favorites',
  //   },
  // }),
  // createConstantMenuItem({
  //   key: 'announcement',
  //   label: dictionary.announcementLabel,
  //   title: dictionary.announcementTitle,
  //   location: '/live/announcement',
  //   activeOn: 'prefix-match',
  //   dataGaValues: {
  //     ['data-ga-event']: 'leftmenu-live-announce',
  //   },
  // }),
];

const ALL_LIVE_ITEM: ConstantMenuItem =
  createConstantMenuItem({
    key: 'live',
    label: dictionary.liveLabel,
    title: dictionary.liveLabel,
    location: '/live',
    activeOn: 'exact-match',
    dataGaValues: {
      ['data-ga-event']: 'leftmenu-live-allEvents',
    },
  });

export const allMatchesCountSelector = createAllMatchesCountSelector(sportMenuItems);

const allLiveItemSelector = createSelector(
  allMatchesCountSelector,
  () => ALL_LIVE_ITEM,
  (allMatchesCount, allLiveItem) => {
    return { ...allLiveItem, entity: { matchesCount: allMatchesCount } };
  });

const rootMenuItemEntries = createSelector(
  // (state: ReduxState) => sportsMenuPromotedMenuItems(state),
  allLiveItemSelector,
  sportMenuItems,
  (
    // promotedItems,
    allLiveItem,
    sportItems,
  ) => {
    return (
      (CONSTANT_MENU_ITEMS as RootMenuItem[])
        // .concat(promotedItems)
        .concat(allLiveItem)
        .concat(sportItems)
    );
  },
);

export const rootMenuItemsWithPathname = (pathname: string) =>
  createActiveItemDetectionSelector(rootMenuItemEntries, pathname);


// -- native menu items grouped by layer entity id --

// todo: consider correct order (by sport/union)...
const tournamentMenuItemsBySportId = createSelector(
  [tournamentMenuItems],
  (tournamentMenuItems) => {
    return groupBy(
      (item) => item.entity.sportId,
      tournamentMenuItems,
    );
  },
);

// const stageMenuItemsByTournamentId = createSelector(
//   [stageMenuItems],
//   (stageMenuItems) => {
//     return groupBy(
//       (item) => item.entity.tournamentId,
//       stageMenuItems,
//     );
//   },
// );

// const matchMenuItemsByStageId = createSelector(
//   [matchMenuItems],
//   (matchMenuItems) => {
//     return groupBy(
//       (item) => item.entity.tournamentStageId,
//       matchMenuItems,
//     );
//   },
// );

// const stagesMenuLayerItemsByTournamentId = createSelector(
//   stageMenuItemsByTournamentId,
//   matchMenuItemsByStageId,
//   (stageMenuItemsByTournamentId, matchMenuItemsByStageId) => {
//     const map = new Map<number, StagesMenuLayerItem[]>();
//
//     stageMenuItemsByTournamentId.forEach((stageMenuItems, tournamentId) => {
//       const items: StagesMenuLayerItem[] = [];
//
//       for (const stageMenuItem of stageMenuItems) {
//         items.push(
//           stageMenuItem,
//           ...(matchMenuItemsByStageId.get(stageMenuItem.stageId) || []),
//         );
//       }
//
//       map.set(tournamentId, items);
//     });
//
//     return map;
//   },
// );


// -- filled menu layers (with items) --

const filledSportTournamentsMenuLayers = createSelector(
  emptySportTournamentsMenuLayers,
  tournamentMenuItemsBySportId,
  (layers, tournamentMenuItemsBySportId) => {
    return layers.map((layer) => ({
      ...layer,
      items: tournamentMenuItemsBySportId.get(layer.sportId) || [],
    }));
  },
);

// const filledStagesMenuLayers = createSelector(
//   emptyStagesMenuLayers,
//   stagesMenuLayerItemsByTournamentId,
//   (layers, stagesMenuLayerItemsByTournamentId) => {
//     return layers.map((layer) => ({
//       ...layer,
//       items: stagesMenuLayerItemsByTournamentId.get(layer.tournamentId) || [],
//     }));
//   },
// );

// --


// -- complete menu layers with navigation state --

// export const sportTournamentsMenuLayers = createSelector(
//   filledSportTournamentsMenuLayers,
//   (state: ReduxState) => currentLocation(state).sportId,
//   (state: ReduxState) => currentLocation(state).tournamentId,
//   (layers, sportId, tournamentId): SportTournamentsMenuLayer[] => {
//     const visibleLayerKey = sportId ? `sport-${sportId}` : null;
//     const activeItemKey = tournamentId ? `tournament-${tournamentId}` : null;
//     return applyNavigationState(layers, visibleLayerKey, activeItemKey);
//   },
// );

export const sportTournamentsMenuLayersByPathname = createSelector(
  filledSportTournamentsMenuLayers,
  (_: ReduxState, pathname: string) => pathname,
  (layers, pathname): SportTournamentsMenuLayer[] => {
    const { sportId, tournamentUnionId } = parseLocationPath(pathname);

    const visibleLayerKey = sportId ? `sport-${sportId}` : null;
    const activeItemKey = tournamentUnionId ? `tournament-${tournamentUnionId}` : null;
    return applyNavigationState(layers, visibleLayerKey, activeItemKey);
  },
);

// export const stagesAndMatchesMenuLayers = createSelector(
//   filledStagesMenuLayers,
//   (state: ReduxState) => currentLocation(state).tournamentId,
//   (state: ReduxState) => currentLocation(state).tournamentStageId,
//   (state: ReduxState) => currentLocation(state).matchId,
//   (layers, tournamentId, stageId, matchId): StagesMenuLayer[] => {
//     const visibleLayerKey = tournamentId ? `tournament-${tournamentId}` : null;
//
//     let activeItemKey = null;
//     if (matchId) {
//       activeItemKey = `match-${matchId}`;
//     }
//     else if (stageId) {
//       activeItemKey = `stage-${stageId}`;
//     }
//
//     return applyNavigationState(layers, visibleLayerKey, activeItemKey);
//   },
// );

// export const activeLevel = (state: ReduxState): MenuLayerLevel => {
//   if (!requested(state) || entityLoading(state)) {
//     return '0';
//   }
//
//   const location = currentLocation(state);
//
//   if (location.tournamentId && (
//     tournaments(state).has(location.tournamentId)
//   )) {
//     return '2';
//   }
//
//   if (location.sportId && (
//     sports(state).has(location.sportId)
//   )) {
//     return '1';
//   }
//
//   return '0';
// };
